import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertNoPermission from "../../alerts/AlertNoPermission";

class ApplicationStatuses extends Component {
    state = { applicationStatusesList: [], noPermission: false };

    getApplicationStatuses = async () => {
        const { fetchURL, defaultValue, onShowAlert, t } = this.props;
        try {
            const response = await fetch(`${fetchURL}/application-statuses`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const appStatList = fetchedData.partAppStatList;
                        if (defaultValue === "all") {
                            appStatList.push({
                                key: appStatList.length + 1,
                                value: "all",
                                text: t("selectAll"),
                            });
                        }

                        this.setState({ applicationStatusesList: appStatList });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getApplicationStatuses();
    }

    render() {
        const { applicationStatusesList, noPermission } = this.state;
        const { defaultValue, onPartAppStatSelected, req, t } = this.props;
        return (
            <Fragment>
                <Form.Label>
                    {t("applications.appStatuses")} {req && <span className="required">*</span>}
                </Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : (
                    <Dropdown
                        value={defaultValue}
                        id="appStatDropdown"
                        className={req ? "req mb-3" : "mb-3"}
                        placeholder={t("applications.clickToChooseStatus")}
                        fluid
                        selection
                        options={applicationStatusesList}
                        onChange={(event, { value }) => {
                            onPartAppStatSelected(value);
                        }}
                    />
                )}
            </Fragment>
        );
    }
}

export default ApplicationStatuses;
